import pinia from "@/plugins/PiniaPlugin";
import { storeToRefs } from "pinia";

import { checkForValidSession, useAuthStore } from "@/stores/Auth";

import { goFetch } from "@/utils/network-utils";
import type { UserActivityEventPayload } from "@/types/api/fetch";
import type { ContentfulItem } from "@/types/entities";

import { consoleLoggerFactory, getDefaultLoggerOptions, ILogger, LogLevels } from "@/types/console-logger";
import { clientStateManager } from "@/services/error-services";
const logger: ILogger = consoleLoggerFactory.create( getDefaultLoggerOptions( LogLevels.ERROR ) );

function notifyUserActivity( activity: UserActivityEventPayload ) {
    const { authToken } = storeToRefs( useAuthStore( pinia ) );
    if ( authToken.value ) {
        checkForValidSession( authToken.value ).then( ( validSession: boolean ) => {
            if ( validSession ) {
                goFetch<void, UserActivityEventPayload>( {
                    endpoint: 'ux/user/appaction',
                    authToken: authToken.value,
                    payload: activity
                } ).then( () => logger.info( 'SUCCESS' ) )
                   .catch( ( err: any ) => logger.warn( 'FAILURE: ', JSON.stringify( err.message ) ) );
            }
        } ).catch( () => { /* IGNORE */ } );
    }
}

export function reportContentViewEvent( content: ContentfulItem | undefined, contentType: string ) {
    if ( content ) {
        const products = content.products;
        if ( products.length > 0 ) {
            notifyUserActivity( {
                topic: `${ contentType }_view`,
                scopes: [
                    { topic: 'content_id', value: content.contentfulId }
                ]
            } );
        }
    }
}

export function reportVideoPlayEvent( videoId: string ) {
    if ( videoId ) {
        notifyUserActivity( {
            topic: `video_view`,
            scopes: [
                { topic: 'video_id', value: videoId }
            ]
        } );
    }
}

export function reportSearchEvent( symbol: string ) {
    if ( symbol ) {
        notifyUserActivity( {
            topic: `search`,
            scopes: [ { topic: 'symbol', value: symbol } ]
        } );
    }
}

export function reportSectorViewEvent( sectorId: number ) {
    if ( sectorId ) {
        notifyUserActivity( {
            topic: `sector_view`,
            scopes: [ { topic: 'sector_id', value: `${ sectorId }` } ]
        } );
    }
}

export function reportUserAdClick( utmAd: string ) {
    if ( utmAd ) {
        notifyUserActivity( {
            topic: `ad_viewed`,
            scopes: [ { topic: 'ad_id', value: utmAd } ]
        } );
    }
}